module.exports = "/images/sites.svg?6684f8e4fd61e8897bfbf3239f9fad48";